import mutations from './mutations';
import actions from './actions';
import getters from './getters';

const AuthorizationModule = {
  state: {
      accessToken: null,
      userInformation: {
        name: null,
        nameidentifier: null,
        lastVisitDateTimeUTC: null,
        deviceKey: null,
        role: null,
        userdata: null
      }
  },
  mutations: mutations,
  actions: actions,
  getters: getters
};

export default AuthorizationModule;
